import type { Sx } from '@evrone-erp/uikit';
export const styles: Record<string, Sx> = {
  header: {
    marginBottom: '14px'
  },
  plate: {
    minHeight: 360,
    display: 'flex',
    flexDirection: 'column'
  },
  innerHeaderAndError: {
    flexShrink: 0,
    marginBottom: 10
  },
  errorText: {
    color: 'error.dark',
    display: 'block',
    whiteSpace: 'pre-wrap'
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 6
  },
  footer: {
    marginTop: 10,
    flexShrink: 0
  }
};